import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Typography,
} from "@mui/material";
import React from "react";

import DownArrow from "../../../../styles/svg/downArrow.svg";
import CustomMenu from "../../../../components/Menu";
import { CustomButton } from "../../../../components/Button/Button";
import BoardSearch from "./BoardSearch";
import BoardList from "./BoardList";
import SelectAllBoardMenuItem from "./SelectAllBoardMenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useBoardsFilterState } from "../../hooks/useBoardsFilterState";
import "./filters.scss";

const BoardChip = React.memo(({ checkedList, onDelete }) => (
  <Chip
    label={
      <div className="d-flex justify-content-space-between">
        <p className="filter-name">board</p>
        {checkedList.length > 0 && (
          <p className="filter-count">{checkedList.length}</p>
        )}
      </div>
    }
    className="filter-chip"
    {...(checkedList.length > 0 ? { onDelete } : {})}
  />
));

const MemoizedBoardList = React.memo(({ boards, checkedList, onSelect }) => (
  <BoardList boards={boards} checkedList={checkedList} onSelect={onSelect} />
));

function Boards({ isAssignToMe = false }) {
  const {
    anchorEl,
    checkedList,
    filteredItems,
    handleButtonClick,
    handleClose,
    handleDeleteBoard,
    isAllSelected,
    isMobile,
    open,
    searchQuery,
    selectAll,
    selectBoard,
    setSearchQuery,
  } = useBoardsFilterState({ isAssignToMe });

  return (
    <div>
      {isMobile ? (
        <Accordion className="filter-accordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header">
            <Typography component="span">
              By Board
              <span className="filter-count">
                {checkedList.length === 0 ? "" : checkedList.length}
              </span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0px 12px 12px" }}>
            <BoardSearch
              onSearch={setSearchQuery}
              searchQuery={searchQuery}
            />
            <div className="filter-accordion-content">
              {!searchQuery && (
                <SelectAllBoardMenuItem
                  selectAll={selectAll}
                  checked={isAllSelected}
                  className="select-all-menu-item"
                />
              )}
              <MemoizedBoardList
                boards={filteredItems}
                checkedList={checkedList}
                onSelect={selectBoard}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      ) : (
        <CustomButton
          variant="outlined"
          color="primary"
          id="epics-board-dropdown"
          aria-haspopup="true"
          onClick={handleButtonClick}
          endIcon={<img src={DownArrow} alt="down arrow" />}
          className="white-button ml-2 board-filter-button board-filter-chip-button">
          <BoardChip checkedList={checkedList} onDelete={handleDeleteBoard} />
        </CustomButton>
      )}
      <CustomMenu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="assign-board-owner-list board-dropdown-menu">
        <Box className="search-box">
          <BoardSearch
            onSearch={setSearchQuery}
            searchQuery={searchQuery}
          />
        </Box>
        {!searchQuery && (
          <SelectAllBoardMenuItem
            selectAll={selectAll}
            checked={isAllSelected}
            className="select-all-menu-item-in-Allboards"
          />
        )}
        <MemoizedBoardList
          boards={filteredItems}
          checkedList={checkedList}
          onSelect={selectBoard}
        />
      </CustomMenu>
    </div>
  );
}

export default React.memo(Boards);
